<div class="flex flex-col items-center text-center p-6 space-y-4">
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css" />


    <div class="bg-custom-blue rounded-full h-[90px] w-[90px]  flex items-center justify-center">
        <i class="fas fa-check text-white custom-thick-icon  fa-3x"></i>
    </div>

    <div class="mb-6">
        <h2 class=" text-3xl font-semibold mt-2">Credit Card Added</h2>
        <p class="text-left mt-4 text-lg">Your credit card has been added successfully.</p>
        <p class=" text-lg">It's now available for all future transactions and payments.</p>

        <button pButton class=" h-[40px] !bg-[var(--p-info-500)] !border-[var(--p-info-500)] 
              hover:!bg-[var(--p-info-600)] hover:!border-[var(--p-info-600)] 
              active:!bg-[var(--p-info-700)] active:!border-[var(--p-info-700)] rounded-m w-full relative flex items-center justify-center mt-6"
            [rounded]="true" (click)="onDone()">
            <i class="pi pi-credit-card left-3">
            </i>
            <span class="font-semibold text-white text-center w-full text-base">
                Done
            </span>
        </button>
    </div>
</div>